import React from 'react'

const FormInput = ({
  label,
  required = false,
  value,
  onChange,
  inputRef,
  onKeyDown,
  placeholder,
  type = 'text',
  allowNumberOnly = false,
  allowDecimal = false,
  readOnly = false,
  min,
  step,
}) => {
  const handleChange = (e) => {
    let val = e.target.value

    if (allowNumberOnly || allowDecimal) {
      const regex = allowDecimal ? /^[0-9]*\.?[0-9]*$/ : /^[0-9]*$/

      if (!regex.test(val)) return
    }

    onChange(val)
  }

  return (
    <div className="form-field">
      <label>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </label>

      <input
        type={type}
        ref={inputRef}
        value={value}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        readOnly={readOnly}
        inputMode={allowNumberOnly || allowDecimal ? 'numeric' : undefined}
        min={min}
        step={step}
        style={
          readOnly
            ? { backgroundColor: '#f0f0f0', cursor: 'not-allowed' }
            : undefined
        }
      />
    </div>
  )
}

export default FormInput
